import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CustomLegendEl } from '@digilize/shared/feature/modules/charts/src';
import Highcharts, { Chart } from 'highcharts';
import enableExporting from 'highcharts/modules/exporting';

import { ChartExportData } from '../charts-group/charts-group.component';
import { ChartType } from '@digilize/shared/definitions/src';

@Component({
  selector: 'suc-research-chart',
  templateUrl: './research-chart.component.html',
  styleUrls: ['./research-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ResearchChartComponent implements OnInit {
  update = false;
  _highchartsOptions = null;
  chartInstance: Chart;
  ChartType = ChartType;
  @Input() chartType: ChartType;
  @Input() set highchartsOptions(highchartsOptions: Highcharts.Options) {
    this._highchartsOptions = null;
    setTimeout(() => {
      this._highchartsOptions = highchartsOptions;
      this.update = true;
    }, 0);
  }
  @Input() isLoading = false;
  @Input() customLegend: CustomLegendEl[] = null;
  @Output() chartInstanceSet = new EventEmitter<ChartExportData>();
  Highcharts = Highcharts;
  constructor() {
    enableExporting(Highcharts);
  }

  ngOnInit(): void {}

  emitChartInstance(chartInstance: Chart) {
    this.chartInstance = chartInstance;
    this.chartInstanceSet.emit({ chart: this.chartInstance, options: this._highchartsOptions });
  }
}
